import { Select } from '@/components/Select'
import { useDistributorWorkspace } from '@/contexts/DistributorWorkspaceContext'
import styles from './SouDistribuidorTabsLayout.module.css'

const ALL_CAMPAIGNS_VALUE = ''

export function DistributorWorkspaceSelector() {
  const {
    programs,
    isLoading,
    institutionId,
    campaignId,
    selectedProgram,
    setInstitutionId,
    setCampaignId,
  } = useDistributorWorkspace()

  if (isLoading || programs.length === 0) {
    return null
  }

  const institutionOptions = programs.map((program) => ({
    value: String(program.institution.id),
    label: `${program.institution.name}${program.is_active ? '' : ' (inativo)'}`,
  }))

  const campaignOptions = [
    { value: ALL_CAMPAIGNS_VALUE, label: 'Todas as campanhas' },
    ...(selectedProgram?.allowed_campaigns ?? []).map((campaign) => ({
      value: String(campaign.id),
      label: campaign.title?.trim() || campaign.name,
    })),
  ]

  return (
    <div className={styles.workspaceSelector}>
      <Select
        id="distributor-institution-select"
        label="Instituição"
        icon="mdi:domain"
        value={institutionId != null ? String(institutionId) : ''}
        onChange={(value) => {
          setInstitutionId(value === '' ? null : Number.parseInt(value, 10))
        }}
        options={institutionOptions}
        placeholder="Selecione a instituição"
        disabled={institutionOptions.length <= 1}
      />
      <Select
        id="distributor-campaign-select"
        label="Campanha"
        icon="mdi:bullhorn"
        value={campaignId != null ? String(campaignId) : ALL_CAMPAIGNS_VALUE}
        onChange={(value) => {
          setCampaignId(value === ALL_CAMPAIGNS_VALUE ? null : Number.parseInt(value, 10))
        }}
        options={campaignOptions}
        placeholder="Campanha"
        disabled={!selectedProgram || selectedProgram.allowed_campaigns.length === 0}
      />
    </div>
  )
}
